export interface IBalanceCheckRequestDTO {
  DateRequest: Date
  TransformerId: string
  secondRange: number
}

export interface IBalanceGroupCheckRequestDTO {
  DateRequest: Date
  GroupId: string
  secondRange: number
}
export interface IBalanceRegionCheckRequestDTO {
  DateRequest: Date
  RegionId: string
  secondRange: number
}

//Backend
// SMC = 0
// SMI = 1

export enum TransformerDeviceType {
  SMC,
  SMI,
}

export interface ITransformerSerialType {
  serial: string
  type?: TransformerDeviceType
  updatedAt?: Date
}

export interface IAddMetersModelsDTO {
  transformerId: string
  transformerSerialType: ITransformerSerialType[]
}

export interface IReadingCheckDTO {
  readingHour: Date
  hasReadingPercentage: number
  label: string
  operationId: string
}

export interface ICheckEffictiveness {
  dateRequested: Date
  transformerId: string
  secondRange: number
}

export interface IBalanceCheckResponse {
  dateTimeRequest: Date
  readingChecks: IReadingCheckDTO[]
}

export interface IMetersBalance {
  serial: string
  finalReading: number
  initialReading: number
  energyConsumed: number
  trafoNumber: string
  initialDate: Date
  finalDate: Date
}

export interface ISmcBalance {
  energyConsumed: number
  finalReading: number
  initialReading: number
  trafoNumber: string
  initialDate: Date
  finalDate: Date
  metersBalance: IMetersBalance[]
}

export interface IBalanceResult {
  initialDateTime: string
  finalDateTime: string
  transformer: any
  transformerMeterInitialReading: number
  transformerMeterFinalReading: number
  transformerMeterInitialReadingDateTime: string
  transformerMeterFinalReadingDateTime: string
  energyRequired: number
  energyConsumed: number
  streetLighting: number
  energyInjectedConsumers?: number
  energyReverseTransformer?: number
  loss: number
  lossPercentage: number
  smcBalance: ISmcBalance[]
  smiBalance: IMetersBalance[]
}

export interface IGroupBalanceResult {
  initialDateTime: string
  finalDateTime: string
  group: any
  groupInitialReading: number
  groupFinalReading: number
  energyRequired: number
  energyConsumed: number
  streetLighting: number
  loss: number
  lossPercentage: number
  balanceResults: IBalanceResult[]
  smiBalance: IMetersBalance[]
  groupPublicLighting: number
}

export interface IRegionBalance {
  initialDateTime: string
  finalDateTime: string
  region: any
  regionInitialReading: number
  regionFinalReading: number
  energyRequired: number
  energyConsumed: number
  streetLighting: number
  loss: number
  lossPercentage: number
  balanceResultGroups: IGroupBalanceResult[]
  regionPublicLighting: number
}

export interface IBalanceTransformerFilter {
  initialDateTime: Date
  finalDateTime: Date
  transformerId: string
  streetLighting: number
}

export interface IBalanceGroupFilter {
  initialDateTime: Date
  finalDateTime: Date
  groupId: string
  secondRangeInitialDateTime: number
  secondRangeFinalDateTime: number
}

export interface IBalanceRegionFilter {
  initialDateTime: Date
  finalDateTime: Date
  regionId: string
  secondRangeInitialDateTime: number
  secondRangeFinalDateTime: number
}
